module.exports = __webpack_public_path__ + "static/media/erikjankerssies.032b6ab4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/erikjankerssies.webp
// module id = 730
// module chunks = 0